import { toggleGlobalSidebar, toggleMobileMenu } from 'actions'
import Icon from 'atoms/icon'
import breakpoints from 'config/mediaBreakpoints'
import { appRoutes } from 'config/routes'
import AuthContext from 'context/authContext'
import React, { useContext } from 'react'
import { connect } from 'react-redux'
import MediaQuery from 'react-responsive'
import GlobalContext from 'context/globalContext'
import { Link, withRouter } from 'react-router-dom'
import './header.css'

const logo = require('!babel-loader!svg-react-loader?name=Logo!../../../assets/svg/global/2021Logo_white.svg')
const hamburgerMenu = require('!babel-loader!svg-react-loader?name=hamburgerMenuIcon!../../../assets/svg/global/hamburgerMenu.svg')
const filterIcon = require('!babel-loader!svg-react-loader?name=mobileFilterIcon!../../../assets/svg/mobileFilterIcon.svg')

interface HeaderProps {
  children?: React.ReactNode | React.ReactNode[]
  toggleMobileMenu: () => void
  toggleSidebarState: () => void
  brandSwitcher?: React.ReactNode
  summaryParams: string
  deepDiveParams: string
  categoryParams: string
  location
}

const Header: React.FC<HeaderProps> = ({
  children,
  toggleMobileMenu,
  toggleSidebarState,
  brandSwitcher,
  location,
  summaryParams,
  deepDiveParams,
  categoryParams
}) => {
  const { showCategoryLinks } = useContext(AuthContext)
  const path = location?.pathname

  return (
    <>
      <MediaQuery maxWidth={breakpoints.mobileWidth}>
        <header className="appFrameHeader" data-ref="header">
          <Icon
            style={{
              cursor: 'pointer',
              fill: 'var(--pond)',
              height: 16,
              width: 24
            }}
            glyph={hamburgerMenu}
            onClick={e => {
              e.stopPropagation()
              toggleSidebarState()
            }}
            data-ref="sidebarMenuController"
          />

          <Link
            to={{ pathname: '/', search: summaryParams }}
            className="fanaiLogo"
          >
            <Icon
              style={{ width: 114, height: 28, fill: 'white' }}
              glyph={logo}
            />
          </Link>

          <div
            className="mobileFilterIcon"
            style={{
              visibility: path === '/category-data' ? 'hidden' : 'initial'
            }}
            onClick={() => toggleMobileMenu()}
          >
            <Icon glyph={filterIcon} />
          </div>
        </header>
      </MediaQuery>
      <MediaQuery minWidth={breakpoints.largerThanMobileWidth}>
        <header className="appFrameHeader" data-ref="header">
          <Link
            to={{ pathname: appRoutes.myDashboard, search: summaryParams }}
            className="fanaiLogo"
            style={{ borderRight: path === '/category-data' ? 'none' : '' }}
          >
            <Icon
              style={{ width: 114, height: 28, fill: 'white' }}
              glyph={logo}
            />
          </Link>

          {brandSwitcher}

          <div className="links">
            <Link
              to={{ pathname: appRoutes.myDashboard, search: summaryParams }}
              className={
                location.pathname === appRoutes.myDashboard ? 'active' : ''
              }
            >
              Summary
            </Link>
            <Link
              to={{
                pathname: appRoutes.sponsorDeepDive,
                search: deepDiveParams
              }}
              className={
                location.pathname === appRoutes.sponsorDeepDive ? 'active' : ''
              }
            >
              Deep Dive
            </Link>
            {showCategoryLinks && (
              <Link
                to={{
                  pathname: appRoutes.categoryData,
                  search: categoryParams
                }}
                className={
                  location.pathname === appRoutes.categoryData ? 'active' : ''
                }
              >
                Category Data
              </Link>
            )}
          </div>

          {children}
        </header>
      </MediaQuery>
    </>
  )
}

const mapStateToProps = state => ({
  hasMobileMenu: state.appState.dashboardHasFilterPane
})

const mapDispatchToProps = dispatch => ({
  toggleMobileMenu: () => dispatch(toggleMobileMenu()),
  toggleSidebarState: () => dispatch(toggleGlobalSidebar())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
